import ChildFriendly from '@material-ui/icons/ChildFriendly'
import { IconButton } from '@material-ui/core';

const InfantIndicator = (props) => {
  const { paxArr, isMobile } = props
  let mobileStyle = { padding: '0px' }
  let style = { marginLeft: '5px' }

  if (paxArr && paxArr.findIndex(pax => Number(pax.INFT) > 0) !== -1) {
    if (isMobile) {
      return (
        <IconButton style={{ color: "black" }} disabled={true}>
          <div style={{ marginLeft: '5px' }}>
            <ChildFriendly />
          </div>
        </IconButton>
      )
    }
    else {
      return (
        <IconButton style={{ color: "black" }} disabled={true}>
          <span style={{ marginLeft: '5px' }}>
            <ChildFriendly />
          </span>
        </IconButton>
      )
    }
  }

  return (
    <span></span>
  )
}

export default InfantIndicator